import { Rule } from 'antd/lib/form'

export const EMAIL = 'email'
export const PASSWORD = 'password'
export const NEW_PASSWORD = 'new-password'
export const CONFIRM_PASSWORD = 'confirm-password'
export const VERIFICATION_CODE = 'verification-code'

export const PASSWORD_PLACEMENT = 'user-profile-password-form'

export const EMAIL_RULE: Rule[] = [
    {
        required: true,
        message: `Required`,
    },
    {
        type: 'email',
        message: 'Please enter a valid email address',
    },
]
export const VERIFICATION_CODE_LENGTH = 6
export const ENABLE_TITLE = 'Enable two-factor authentication'
export const DISABLE_TITLE = 'Disable two-factor authentication'
export const ENABLE_DESCRIPTION =
    'Scan the unique QR code below into a TOTP app (ie Google Authenticator, Duo Mobile) and enter the code in the field below to activate 2FA on this account.'
export const DISABLE_DESCRIPTION =
    'To disable two-factor authentication please enter the login password for your account below.'
export const DEFAULT_VERIFY_2FA_ERROR_MESSAGE = 'Could not verify 2FA'
export const DEFAULT_DISABLE_2FA_ERROR_MESSAGE = 'Could not disable 2FA'
export const PERMISSION_DENIED = 'Permission Denied'
export const INCORRECT_PASSWORD = 'Incorrect password'

export const ENABLE_PLACEHOLDER = `Enter ${VERIFICATION_CODE_LENGTH} digit code here`
export const DISABLE_PLACEHOLDER = 'Enter your password here'
export const REQUIRED_FIELDS = [PASSWORD, NEW_PASSWORD, CONFIRM_PASSWORD]

export const ENABLE_MFA_RULE = [
    { required: true, message: 'Required' },
    {
        min: VERIFICATION_CODE_LENGTH,
        message: `Verification code should be ${VERIFICATION_CODE_LENGTH} characters`,
    },
    {
        max: VERIFICATION_CODE_LENGTH,
        message: `Verification code should be ${VERIFICATION_CODE_LENGTH} characters`,
    },
]

export const PASSWORD_RULE_REQUIRED = {
    required: true,
    message: 'Please input your password',
}
